import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText, Div, Flex, Gutter, Input, Title } from '@gaiads/telia-react-component-library';

import { httpsUrlRegex } from '../utils';

import styles from './CompanyDevicePolicy.module.scss';

interface CompanyDevicePolicyProps {
  companyDevicePolicy?: string | null;
  setCompanyDevicePolicy: (policyUrl: string) => void;
  validationError?: string;
}

export default function CompanyDevicePolicy(props: CompanyDevicePolicyProps) {
  const { companyDevicePolicy, setCompanyDevicePolicy, validationError } = props;
  const [internalErrorMessage, setInternalErrorMessage] = useState<string | undefined>(validationError);
  const { t } = useTranslation('organizationForm');

  useEffect(() => {
    setInternalErrorMessage(validationError);
  }, [validationError]);

  const handleInputChange = (value: string) => {
    setCompanyDevicePolicy(value);
    setInternalErrorMessage(undefined);
  };

  return (
    <Div padding={{ size: 'lg' }} boxShadow="md">
      <Title size={'sm'}>{t('company_device_policy.company_device_policy')}</Title>
      <Gutter size="layout-5" />
      <Flex directionColumn>
        <BodyText size="md">{t('company_device_policy.paragraph1')}</BodyText>
        <Gutter size="layout-2" />
        <BodyText size="md">{t('company_device_policy.paragraph2')}</BodyText>

        <Gutter size="layout-5" />
        <Div data-testid="company-device-policy">
          <Input
            id="company-device-policy"
            className={styles['customer-organization-form__company-device-policy-inputs-container']}
            label={t('company_device_policy.company_device_policy_input_label')}
            onChange={(_event, value) => handleInputChange(value)}
            value={companyDevicePolicy ?? ''}
            errorText={internalErrorMessage}
            pattern={httpsUrlRegex.source}
          />
        </Div>
      </Flex>
    </Div>
  );
}
